import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import { DateStyles } from '../../constants/CentricConstants';
import DownloadIcon from 'material-ui/svg-icons/file/file-download';

const getTableRowsByMonth = (data, month) => (
    Object.values(data.find(e => !!e && e.month === month).modules)
        .reduce((events, module) => ([...events, ...module.events]), [])
        .map(({ eventId, module, timeStart, attendeesCount, didNotAttendCount }) => (
            <TableRow key={eventId}>
                <TableRowColumn><Link to={`/dashboard/event/${eventId}/attendees`}>{module}</Link></TableRowColumn>
                <TableRowColumn className="tbl-td-number">
                    {new Date(timeStart).toLocaleString('en-GB', DateStyles.fullDateTime)}
                </TableRowColumn>
                <TableRowColumn className="tbl-td-number">{attendeesCount}</TableRowColumn>
                <TableRowColumn className="tbl-td-number">{didNotAttendCount}</TableRowColumn>
                <TableRowColumn className="tbl-td-number">
                    <Link to={`/cent/event/${eventId}/attendees.csv`} target="_blank" title="Download attendee list"><DownloadIcon/></Link>
                </TableRowColumn>
            </TableRow>
        ))
);
const getTableRowsGrouped = (data, reportId) => (
    Object.keys(data).reduce((tableRows, index) => {
        const month = data[index];
        return [
            ...tableRows,
            (
                <TableRow key={index} style={{fontWeight: 'bold'}}>
                    <TableRowColumn>{new Date(month.month).toLocaleString('en-GB', DateStyles.monthYear)}</TableRowColumn>
                    <TableRowColumn className="tbl-td-number">
                        <Link to={`/dashboard/report/${reportId}?month=${month.month}`}>{month.eventsCount}</Link>
                    </TableRowColumn>
                    <TableRowColumn className="tbl-td-number">{month.attendeesCount}</TableRowColumn>
                    <TableRowColumn className="tbl-td-number">{month.didNotAttendCount}</TableRowColumn>
                </TableRow>
            ),
            ...Object.keys(month.modules).map((m) => {
                const { moduleId, module, eventsCount, attendeesCount, didNotAttendCount } = month.modules[Number(m)];
                return (
                    <TableRow key={`${index}_${moduleId}`}>
                        <TableRowColumn>&nbsp;&nbsp;&nbsp;&nbsp;{module}</TableRowColumn>
                        <TableRowColumn className="tbl-td-number">{eventsCount}</TableRowColumn>
                        <TableRowColumn className="tbl-td-number">{attendeesCount}</TableRowColumn>
                        <TableRowColumn className="tbl-td-number">{didNotAttendCount}</TableRowColumn>
                    </TableRow>
                );
            })
        ];

    }, [])
);

const ReportModuleProgress = ({display, onRowSelect, data, reportId, month}) => {
    const tableHeaderProps = {
        enableSelectAll:     display.enableSelectAll,
        displaySelectAll:    display.enableSelectAll,
        adjustForCheckbox:   display.enableSelectAll
    };
    const tableProps = {
        height:              display.height,
        fixedHeader:         display.fixedHeader,
        fixedFooter:         display.fixedFooter,
        displayRowCheckbox:  display.showCheckboxes,
        selectable:          display.selectable,
        multiSelectable:     display.multiSelectable,
    };
    const tableBodyProps = {
        deselectOnClickaway: display.deselectOnClickaway,
        displayRowCheckbox:  display.showCheckboxes,
        showRowHover:        display.showRowHover,
        stripedRows:         display.stripedRows,
    };
    if (!!onRowSelect) {
        tableProps.onRowSelection = onRowSelect;
    }
    return (
        <Table {...tableProps} >
            <TableHeader {...tableHeaderProps} >
                <TableRow>
                    <TableHeaderColumn>{!month ? 'Month' : 'Event'}</TableHeaderColumn>
                    <TableHeaderColumn className="tbl-td-number">{!month ? 'Events' : 'Date'}</TableHeaderColumn>
                    <TableHeaderColumn className="tbl-td-number">Attendees</TableHeaderColumn>
                    <TableHeaderColumn className="tbl-td-number">Did not attend</TableHeaderColumn>
                    {!!month && <TableHeaderColumn className="tbl-td-number"/>}
                </TableRow>
            </TableHeader>
            {(data && data.length > 0) && (
                <TableBody {...tableBodyProps}>
                    {!!month ? getTableRowsByMonth(data, month) : getTableRowsGrouped(data, reportId)}
                </TableBody>
            )}
        </Table>
    );
};

ReportModuleProgress.propTypes = {
    reportId:       PropTypes.number.isRequired,
    month:          PropTypes.string,
    display:        PropTypes.object,
    onRowSelect:    PropTypes.func,
    data:           PropTypes.arrayOf(
        PropTypes.shape({
            month:              PropTypes.string,
            eventsCount:        PropTypes.number,
            attendeesCount:     PropTypes.number,
            didNotAttendCount:  PropTypes.number,
            modules:            PropTypes.shape({
                moduleId:           PropTypes.number,
                module:             PropTypes.string,
                eventsCount:        PropTypes.number,
                attendeesCount:     PropTypes.number,
                didNotAttendCount:  PropTypes.number,
                events:             PropTypes.arrayOf(
                    PropTypes.shape({
                        moduleId:           PropTypes.number,
                        module:             PropTypes.string,
                        eventId:            PropTypes.number,
                        timeStart:          PropTypes.string,
                        timeEnd:            PropTypes.string,
                        attendeesCount:     PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
                        didNotAttendCount:  PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
                        month:              PropTypes.string
                    })
                )
            })
        })
    ),
};

ReportModuleProgress.defaultProps = {
    month:  null,
    display: {
        fixedHeader: true,
        fixedFooter: true,
        stripedRows: false,
        showRowHover: false,
        showCheckboxes: false,
        selectable: false,
        multiSelectable: false,
        enableSelectAll: false,
        deselectOnClickaway: false,
    },
    data: []
};

export default ReportModuleProgress;
